const FIREBASE_POPUP_DISMISS_ERROR_CODES: ReadonlySet<string> = new Set([
  'auth/popup-closed-by-user',
  'auth/cancelled-popup-request',
])

export function getFirebaseAuthErrorCode(error: unknown): string | undefined {
  if (typeof error === 'object' && error !== null && 'code' in error) {
    const code = (error as { code: unknown }).code
    return typeof code === 'string' ? code : undefined
  }
  return undefined
}

export function isFirebaseAuthPopupDismissError(error: unknown): boolean {
  const code = getFirebaseAuthErrorCode(error)
  return code !== undefined && FIREBASE_POPUP_DISMISS_ERROR_CODES.has(code)
}
